(function (root) {
  'use strict';

  /*
   * "Total savings" in the UpCart drawer: compare-at savings (compare-at
   * price minus the price, where a compare-at price is set) PLUS every
   * discount on the cart (2026-10-15). The cart page and checkout still
   * count discounts only. UpCart renders its own markup
   * in a shadow root, so the line is added from here, directly above UpCart's
   * checkout button (under its subtotal), and put back whenever UpCart
   * re-renders. The amount comes from /cart?view=savings
   * (templates/cart.savings.liquid, drawer-only maths; the cart page uses
   * snippets/cart-total-savings.liquid).
   *
   * Refreshes after every /cart/add|change|update|clear request (fetch or XHR)
   * and on the theme's cart events. Hidden when there are no savings.
   */

  var ROW_ATTR = 'data-sculpd-total-savings';
  // 2026-10-15: the amount goes into UpCart's own footer savings line
  // (.upcart-savings-amount, "Discounts ... - EUR x"), so it reads the same as the
  // per-product "(Save EUR x)" lines. Our own "Total savings" row (above
  // Checkout) only shows when UpCart has no savings line, i.e. the cart has
  // compare-at savings but no discount (UpCart only shows that line for
  // discounts). true = always show it as well.
  var SHOW_OWN_ROW = false;
  var UPCART_AMOUNT = '.upcart-savings-amount';
  var CART_CHANGE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var state = { cents: 0, formatted: '', pending: null, timer: null };

  var ICON =
    '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" style="flex:0 0 auto"><path d="M20.6 13.4 13.4 20.6a2 2 0 0 1-2.8 0L3 13V3h10l7.6 7.6a2 2 0 0 1 0 2.8Z"/><circle cx="7.5" cy="7.5" r="1.5"/></svg>';

  function upcartRoot() {
    var host = document.querySelector('#upCart');
    if (!host) return null;
    // Light DOM on the live theme (checked 2026-10-10); a shadow root on some UpCart versions.
    return host.shadowRoot || host;
  }

  /** UpCart's checkout button: the first button/link that reads "Check out" or has a checkout class. */
  function checkoutButton(scope) {
    var nodes = scope.querySelectorAll('button, a');
    for (var i = 0; i < nodes.length; i += 1) {
      var node = nodes[i];
      if (node.closest && node.closest('[' + ROW_ATTR + ']')) continue;
      var cls = String(node.className || '');
      var label = (node.textContent || '').replace(/\s+/g, ' ').trim();
      if (/checkout/i.test(cls) || /^check\s?out\b/i.test(label)) return node;
    }
    return null;
  }

  /** UpCart's footer amount: edit its text node in place (React keeps a reference to it). */
  function renderUpcartAmount(scope) {
    if (!(state.cents > 0)) return;
    var text = '- ' + state.formatted;
    Array.prototype.forEach.call(scope.querySelectorAll(UPCART_AMOUNT), function (el) {
      var node = el.firstChild;
      if (node && node.nodeType === 3 && !node.nextSibling) {
        if (node.nodeValue !== text) node.nodeValue = text;
      } else if (el.textContent !== text) {
        el.textContent = text;
      }
    });
  }

  function render() {
    var scope = upcartRoot();
    if (!scope) return;
    renderUpcartAmount(scope);
    var row = scope.querySelector('[' + ROW_ATTR + ']');
    var upcartHasLine = !!scope.querySelector(UPCART_AMOUNT);
    if (!(state.cents > 0) || (upcartHasLine && !SHOW_OWN_ROW)) {
      if (row) row.remove();
      return;
    }
    var button = checkoutButton(scope);
    if (!button || !button.parentNode) return;
    if (!row) {
      row = document.createElement('div');
      row.setAttribute(ROW_ATTR, '');
      row.setAttribute('style', 'display:flex;align-items:center;gap:6px;margin:0 0 10px;font-size:13px;font-weight:700;letter-spacing:.04em;text-transform:uppercase;line-height:1.3;');
    }
    var html = ICON + '<span>Total savings</span> <span data-amount style="text-transform:none;letter-spacing:0">' + state.formatted + '</span>';
    if (row.innerHTML !== html) row.innerHTML = html;
    if (row.nextSibling !== button || row.parentNode !== button.parentNode) {
      button.parentNode.insertBefore(row, button);
    }
  }

  function refresh() {
    if (state.pending) return state.pending;
    state.pending = root
      .fetch('/cart?view=savings', { credentials: 'same-origin' })
      // NO "Accept: application/json" header: with it Shopify returns the
      // plain /cart.js JSON and ignores ?view=savings (no "cents" -> 0 ->
      // nothing was ever shown in the drawer).
      .then(function (response) {
        return response.text();
      })
      .then(function (text) {
        var data = JSON.parse(text);
        state.cents = parseInt(data.cents, 10) || 0;
        state.formatted = String(data.formatted || '');
        render();
      })
      .catch(function () {
        /* keep the last known value */
      })
      .then(function () {
        state.pending = null;
      });
    return state.pending;
  }

  function refreshSoon() {
    root.clearTimeout(state.timer);
    state.timer = root.setTimeout(refresh, 150);
  }

  function isCartChange(url) {
    try {
      return CART_CHANGE.test(new URL(String(url), root.location.href).pathname);
    } catch (e) {
      return false;
    }
  }

  // ---- Cart changes: fetch + XHR, whoever makes them (UpCart, the PDP, the theme) ----
  if (typeof root.fetch === 'function' && !root.fetch.sculpdSavings) {
    var nativeFetch = root.fetch;
    var patched = function (input) {
      var url = input && input.url ? input.url : input;
      var result = nativeFetch.apply(this, arguments);
      if (isCartChange(url)) {
        result.then(refreshSoon, refreshSoon);
      }
      return result;
    };
    patched.sculpdSavings = true;
    root.fetch = patched;
  }
  if (root.XMLHttpRequest && !root.XMLHttpRequest.prototype.sculpdSavings) {
    var open = root.XMLHttpRequest.prototype.open;
    root.XMLHttpRequest.prototype.open = function (method, url) {
      if (isCartChange(url)) this.addEventListener('loadend', refreshSoon);
      return open.apply(this, arguments);
    };
    root.XMLHttpRequest.prototype.sculpdSavings = true;
  }
  ['cart:updated', 'ajaxProduct:added', 'cart:build'].forEach(function (name) {
    document.addEventListener(name, refreshSoon);
  });

  // ---- UpCart re-renders: put the line back (no refetch) ----
  var watched = null;
  function watch() {
    var scope = upcartRoot();
    if (!scope || scope === watched) return;
    watched = scope;
    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i += 1) {
        var target = records[i].target;
        var ours = target.nodeType === 1 && target.closest && target.closest('[' + ROW_ATTR + ']');
        if (!ours) {
          render();
          return;
        }
      }
    }).observe(scope, { childList: true, subtree: true, characterData: true });
    render();
  }

  new MutationObserver(watch).observe(document.documentElement, { childList: true, subtree: true });
  watch();
  refresh();

  root.SculpdCartSavings = { refresh: refresh, render: render };
})(window);
